export default "__VITE_ASSET__I$d11lQP__"